(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
  const calm = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const LK = window.LK || {};
  const root = (LK.root || '/').replace(/\/?$/, '/');
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- money ---------- */
  const money = cents => {
    const n = (cents || 0) / 100;
    const fmt = (d, th, dec) => {
      const p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p[1] ? p[0] + dec + p[1] : p[0];
    };
    const map = {
      amount: () => fmt(2, ',', '.'),
      amount_no_decimals: () => fmt(0, ',', '.'),
      amount_with_comma_separator: () => fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => fmt(0, '.', ','),
      amount_with_apostrophe_separator: () => fmt(2, "'", '.'),
      amount_no_decimals_with_space_separator: () => fmt(0, ' ', '.'),
      amount_with_space_separator: () => fmt(2, ' ', ',')
    };
    return (LK.money || 'Rs. {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (map[k] || map.amount)());
  };

  /* ---------- page load ---------- */
  requestAnimationFrame(() => setTimeout(() => document.body.classList.remove('load'), 120));

  /* ---------- footer wordmark fit ---------- */
  const ft = $('#fmarkT');
  const fit = () => {
    if (!ft) return;
    const fm = ft.parentNode;
    fm.style.fontSize = '100px';
    const w = ft.getBoundingClientRect().width;
    if (w > 0) fm.style.fontSize = (100 * fm.clientWidth * 0.96 / w) + 'px';
  };
  fit();
  addEventListener('resize', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

  /* ---------- toast ---------- */
  const toastEl = $('#toast');
  let toastT;
  const toast = msg => {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('on'), 2600);
  };

  /* ---------- hero parallax ---------- */
  const hero = $('#hero');
  if (hero && fine && !calm) {
    const shots = $$('.shot', hero);
    let raf = 0;
    hero.addEventListener('pointermove', e => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const r = hero.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        shots.forEach(s => {
          const d = +s.dataset.depth || 8;
          s.style.transition = 'transform .25s linear';
          s.style.transform = `translate(${x * d}px,${y * d}px) rotate(${x * d * 0.12}deg)`;
        });
      });
    });
    hero.addEventListener('pointerleave', () => shots.forEach(s => { s.style.transition = ''; s.style.transform = ''; }));
  }

  /* ---------- product cards: tilt (desktop) / one-time flip (touch) ---------- */
  if (fine && !calm) {
    $$('.card-box').forEach(box => {
      box.addEventListener('pointermove', e => {
        const r = box.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        box.style.transitionDuration = '.12s';
        box.style.transform = `perspective(900px) rotateY(${x * 9}deg) rotateX(${-y * 9}deg) scale(1.015)`;
      });
      box.addEventListener('pointerleave', () => { box.style.transitionDuration = ''; box.style.transform = ''; });
    });
  }
  if (!fine && !calm && 'IntersectionObserver' in window) {
    const co = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('seen'); co.unobserve(e.target); }
    }), { threshold: 0.7 });
    $$('.card').forEach(c => co.observe(c));
  }

  /* ---------- category rows: floating preview ---------- */
  const peek = $('#peek'), peekImg = $('#peekImg');
  if (peek && peekImg && fine) {
    let px = 0, py = 0, tx = 0, ty = 0, rot = 0, running = false;
    const loop = () => {
      const dx = tx - px;
      px += dx * 0.12; py += (ty - py) * 0.12;
      rot += ((calm ? 0 : Math.max(-14, Math.min(14, dx * 0.25))) - rot) * 0.1;
      peek.style.transform = `translate(${px + 28}px,${py - peek.offsetHeight / 2}px) rotate(${rot}deg)`;
      if (running) requestAnimationFrame(loop);
    };
    $$('.cats a[data-peek]').forEach(a => {
      a.addEventListener('pointerenter', () => {
        peekImg.src = a.dataset.peek;
        peek.classList.add('on');
        if (!running) { running = true; loop(); }
      });
      a.addEventListener('pointerleave', () => { peek.classList.remove('on'); setTimeout(() => { if (!peek.classList.contains('on')) running = false; }, 600); });
    });
    addEventListener('pointermove', e => { tx = e.clientX; ty = e.clientY; }, { passive: true });
  }

  /* ---------- denim by weight ---------- */
  const wtabs = $$('.wtab');
  if (wtabs.length) {
    const views = $$('#wview .ph'), go = $('#wgo');
    const pick = i => {
      wtabs.forEach((t, k) => t.setAttribute('aria-selected', k === i ? 'true' : 'false'));
      views.forEach((p, k) => p.classList.toggle('on', k === i));
      if (go && wtabs[i].dataset.url) go.href = wtabs[i].dataset.url;
    };
    wtabs.forEach((t, i) => {
      t.addEventListener('click', () => pick(i));
      if (fine) t.addEventListener('pointerenter', () => pick(i));
    });
  }

  /* ---------- cart ---------- */
  const drawer = $('#drawer'), itemsEl = $('#items'), countEl = $('#count'), totalEl = $('#total');
  let lastFocus = null;
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const getCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(r => r.json());
  const sized = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  const renderCart = cart => {
    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) totalEl.innerHTML = money(cart.total_price);
    if (!itemsEl) return;
    itemsEl.classList.remove('busy');
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="empty">Your cart is empty. Pick a size on any piece to add it.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(it => `
      <div class="item">
        <a class="ph" href="${esc(it.url)}">${it.image ? `<img alt="" src="${esc(sized(it.image, 200))}">` : ''}</a>
        <div>
          <h4><a href="${esc(it.url)}">${esc(it.product_title)}</a></h4>
          ${it.variant_title ? `<small>${esc(it.variant_title)}</small>` : ''}
          <div class="q">
            <button type="button" data-line="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Decrease quantity">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-line="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="rmv" data-line="${esc(it.key)}" data-q="0">Remove</button>
        </div>
        <strong>${money(it.final_line_price)}</strong>
      </div>`).join('');
  };

  const openCart = open => {
    if (!drawer) return;
    document.body.classList.toggle('cart-open', open);
    drawer.inert = !open;
    if (open) { lastFocus = document.activeElement; const c = $('#closeCart'); if (c) c.focus(); }
    else if (lastFocus) lastFocus.focus();
  };

  const bump = () => {
    if (!countEl) return;
    countEl.classList.remove('bump');
    void countEl.offsetWidth;
    countEl.classList.add('bump');
  };

  const addToCart = async (id, qty) => {
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: json, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Could not add this item. Try again.'); return false; }
      renderCart(await getCart());
      bump();
      if (LK.template === 'cart') { location.reload(); return true; }
      openCart(true);
      return true;
    } catch (e) {
      toast('Could not reach the cart. Check your connection and try again.');
      return false;
    }
  };

  const changeLine = async (key, qty) => {
    if (itemsEl) itemsEl.classList.add('busy');
    try {
      const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: json, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: qty }) });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Could not update the cart.'); renderCart(await getCart()); return; }
      renderCart(data);
    } catch (e) {
      if (itemsEl) itemsEl.classList.remove('busy');
      toast('Could not reach the cart. Check your connection and try again.');
    }
  };

  document.addEventListener('click', async e => {
    const add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      const wrap = add.closest('.sizes');
      if (wrap) wrap.classList.add('busy');
      await addToCart(add.dataset.add, 1);
      if (wrap) wrap.classList.remove('busy');
      return;
    }
    const line = e.target.closest('[data-line]');
    if (line) { changeLine(line.dataset.line, Math.max(0, +line.dataset.q)); return; }
  });

  const cartBtn = $('#cartBtn');
  if (cartBtn && drawer && LK.template !== 'cart') {
    cartBtn.addEventListener('click', e => { e.preventDefault(); openCart(true); getCart().then(renderCart).catch(() => {}); });
  }
  const closeCart = $('#closeCart'), scrim = $('#scrim');
  if (closeCart) closeCart.addEventListener('click', () => openCart(false));
  if (scrim) scrim.addEventListener('click', () => openCart(false));
  if (drawer) getCart().then(renderCart).catch(() => {});

  /* ---------- mobile menu ---------- */
  const menu = $('#menu'), menuBtn = $('#menuBtn'), menuClose = $('#menuClose');
  const openMenu = open => {
    if (!menu) return;
    document.body.classList.toggle('menu-open', open);
    menu.inert = !open;
    document.documentElement.style.overflowY = open ? 'hidden' : '';
    const f = open ? menuClose : menuBtn;
    if (f) f.focus();
  };
  if (menu) {
    $$('#menuNav a').forEach((a, i) => { a.style.transitionDelay = (0.12 + i * 0.04) + 's'; });
    if (menuBtn) menuBtn.addEventListener('click', () => openMenu(true));
    if (menuClose) menuClose.addEventListener('click', () => openMenu(false));
  }
  addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (document.body.classList.contains('menu-open')) openMenu(false);
    if (document.body.classList.contains('cart-open')) openCart(false);
  });

  /* ---------- product page ---------- */
  const pj = $('#productJson'), form = $('#productForm');
  if (pj && form) {
    let product = null;
    try { product = JSON.parse(pj.textContent); } catch (e) { product = null; }
    const idIn = form.querySelector('[name="id"]');
    const atc = $('#atc'), atcText = atc && atc.querySelector('[data-atc-text]');
    const sAtc = $('#stickyAtc'), sPrice = $('#stickyPrice'), priceBox = $('#pdpPrice');
    const qtyIn = $('#pdpQty'), gallery = $('#pdpGallery');
    const groups = $$('.opt', form);
    const selected = () => groups.map(g => { const c = g.querySelector('input:checked'); return c ? c.value : null; });

    const setState = v => {
      const ok = !!(v && v.available);
      const label = !v ? 'Unavailable' : ok ? 'Add to cart' : 'Sold out';
      if (atc) atc.disabled = !ok;
      if (atcText) atcText.textContent = label;
      if (sAtc) { sAtc.disabled = !ok; sAtc.textContent = label; }
      if (!v) return;
      idIn.value = v.id;
      if (priceBox) {
        const now = priceBox.querySelector('.now'), was = priceBox.querySelector('s'), off = priceBox.querySelector('.off');
        now.innerHTML = money(v.price);
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        was.hidden = !sale; off.hidden = !sale;
        if (sale) { was.innerHTML = money(v.compare_at_price); off.textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + '% off'; }
      }
      if (sPrice) sPrice.innerHTML = money(v.price);
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
      if (gallery && v.featured_image && v.featured_image.id) {
        const figs = $$('figure', gallery);
        const hit = figs.find(f => f.dataset.imageId == v.featured_image.id);
        if (hit) { figs.forEach(f => { f.style.order = f === hit ? '-1' : ''; }); gallery.scrollLeft = 0; }
      }
    };

    const refresh = () => {
      if (!product) return;
      const sel = selected();
      groups.forEach((g, i) => {
        const out = g.querySelector('[data-opt-val]');
        if (out && sel[i] != null) out.textContent = sel[i];
        $$('.pill', g).forEach(p => {
          const val = p.querySelector('input').value;
          const any = product.variants.some(v => v.available && v.options[i] === val && v.options.every((o, k) => k === i || sel[k] == null || o === sel[k]));
          p.classList.toggle('na', !any);
        });
      });
      const v = groups.length ? product.variants.find(x => x.options.every((o, k) => o === sel[k])) : product.variants.find(x => String(x.id) === String(idIn.value)) || product.variants[0];
      setState(v);
    };
    groups.forEach(g => g.addEventListener('change', refresh));
    if (product && groups.length) refresh();

    $$('[data-qty]', form).forEach(b => b.addEventListener('click', () => {
      if (qtyIn) qtyIn.value = Math.max(1, (parseInt(qtyIn.value, 10) || 1) + (+b.dataset.qty));
    }));

    let fallback = false;
    form.addEventListener('submit', async e => {
      if (fallback) return;
      const sub = e.submitter;
      if (sub && sub !== atc) return; /* dynamic checkout buttons handle themselves */
      e.preventDefault();
      if (!atc || atc.disabled) return;
      atc.classList.add('busy');
      if (atcText) atcText.textContent = 'Adding';
      const ok = await addToCart(idIn.value, qtyIn ? Math.max(1, parseInt(qtyIn.value, 10) || 1) : 1);
      atc.classList.remove('busy');
      if (atcText) atcText.textContent = ok ? 'Added' : 'Add to cart';
      if (ok) setTimeout(() => { if (atcText && !atc.disabled) atcText.textContent = 'Add to cart'; }, 1600);
    });
    if (sAtc && atc) sAtc.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(atc); else { fallback = true; atc.click(); } });

    /* sticky bar shows once the main button scrolls away */
    const bar = $('#stickybar');
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(en => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (sAtc) sAtc.tabIndex = on ? 0 : -1;
      })).observe(atc);
    }

    /* gallery: click to zoom on desktop, slide counter on phone */
    if (gallery) {
      const figs = $$('figure', gallery), idx = $('#pdpIdx');
      if (fine) figs.forEach(f => {
        f.addEventListener('click', () => { const z = f.classList.toggle('zoomed'); if (!z) { const im = f.querySelector('img'); if (im) im.style.transformOrigin = ''; } });
        f.addEventListener('pointermove', e => {
          if (!f.classList.contains('zoomed')) return;
          const r = f.getBoundingClientRect(), im = f.querySelector('img');
          if (im) im.style.transformOrigin = `${(e.clientX - r.left) / r.width * 100}% ${(e.clientY - r.top) / r.height * 100}%`;
        });
        f.addEventListener('pointerleave', () => f.classList.remove('zoomed'));
      });
      if (idx) {
        let t = 0;
        gallery.addEventListener('scroll', () => {
          cancelAnimationFrame(t);
          t = requestAnimationFrame(() => {
            const mid = gallery.scrollLeft + gallery.clientWidth / 2;
            const ordered = figs.slice().sort((a, b) => a.offsetLeft - b.offsetLeft);
            let best = 0, bd = Infinity;
            ordered.forEach((f, i) => { const d = Math.abs(f.offsetLeft + f.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
            idx.textContent = best + 1;
          });
        }, { passive: true });
      }
    }
  }

  /* ---------- collection sort ---------- */
  const sortBy = $('#sortBy');
  if (sortBy) sortBy.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', sortBy.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* ---------- cursor label + magnetic buttons (desktop only) ---------- */
  if (fine && !calm) {
    const tag = $('#ctag');
    if (tag) {
      let cx = 0, cy = 0, x = 0, y = 0, live = false;
      const loop = () => {
        x += (cx - x) * 0.22; y += (cy - y) * 0.22;
        tag.style.transform = `translate(${x}px,${y}px) scale(${tag.classList.contains('on') ? 1 : 0.6})`;
        if (live) requestAnimationFrame(loop);
      };
      addEventListener('pointermove', e => {
        cx = e.clientX; cy = e.clientY;
        const lab = e.target.closest && e.target.closest('[data-cursor]');
        const on = !!(lab && lab.dataset.cursor);
        if (on) tag.textContent = lab.dataset.cursor;
        tag.classList.toggle('on', on);
        if (on && !live) { live = true; x = cx; y = cy; loop(); }
        if (!on && live) setTimeout(() => { if (!tag.classList.contains('on')) live = false; }, 400);
      }, { passive: true });
    }
    $$('[data-mag]').forEach(b => {
      b.addEventListener('pointermove', e => {
        const r = b.getBoundingClientRect();
        b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.28}px,${(e.clientY - r.top - r.height / 2) * 0.4}px)`;
      });
      b.addEventListener('pointerleave', () => { b.style.transform = ''; });
    });
  }

  /* ---------- scroll: selvedge progress, nav hide, marquee lean, parallax ---------- */
  const prog = $('#prog'), nav = $('#nav'), mq = $('.marquee'), closerImg = $('#closerImg');
  let last = scrollY, leanT;
  const onScroll = () => {
    const y = scrollY, max = document.documentElement.scrollHeight - innerHeight;
    if (prog) prog.style.transform = `scaleY(${max > 0 ? y / max : 0})`;
    const busy = document.body.classList.contains('cart-open') || document.body.classList.contains('menu-open');
    if (nav) nav.classList.toggle('hide', y > last && y > 400 && !busy);
    if (!calm) {
      if (mq) {
        const lean = Math.max(-18, Math.min(18, (y - last) * 0.6));
        mq.style.transform = `rotate(-1.2deg) scale(1.02) skewX(${-lean}deg)`;
        clearTimeout(leanT);
        leanT = setTimeout(() => { mq.style.transition = 'transform .6s'; mq.style.transform = ''; setTimeout(() => { mq.style.transition = ''; }, 600); }, 120);
      }
      if (closerImg) {
        const r = closerImg.parentNode.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) closerImg.style.transform = `translateY(${(r.top / innerHeight) * -6}%)`;
      }
    }
    last = y;
  };
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- heading reveals ---------- */
  const heads = $$('.head:not(.in)');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    }), { threshold: 0.3 });
    heads.forEach(h => io.observe(h));
  } else heads.forEach(h => h.classList.add('in'));
})();
